import React from 'react';
import { Icon, IconComponent } from './icon';
import src from 'grpn-mx-mixer/dist/images/icons/social-facebook.svg';

export const IconSocialFacebook: IconComponent = props => <Icon {...props} src={src} />;
